<template>
	<view class="box">
		<view class="title">核销订单</view>
		<view class="item">
			<view class="item-user">
				<view class="item-user-image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="item-user-info">
					<text>张海涛</text>
					<text>18155665556</text>
				</view>
			</view>
			<view class="item-info">订单备注：11月22日来拿</view>
		</view>
		<view class="item">
			<view class="item-title">商品列表</view>
			<view class="row">
				<view class="row-image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="row-info">
					中联艾禾宽齿 适用雷沃/中联/久保田
				</view>
				<view class="row-price">
					<text>¥499.00</text>
					<text>x1</text>
				</view>
			</view>
		</view>
		<view style="width: 100%; height: calc(env(safe-area-inset-bottom) + 108rpx);"></view>
		<view class="button">确认核销</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 30rpx;
		box-sizing: border-box;
		.button {
			width: calc(100vw - 60rpx);
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #004096;
			border-radius: 44rpx;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			position: fixed;
			left: 30rpx;
			bottom: calc(env(safe-area-inset-bottom) + 20rpx);
		}
		.title {
			font-weight: 600;
			font-size: 32rpx;
			color: #111111;
		}
		.item {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 16rpx;
			margin-top: 30rpx;
			.row {
				width: 100%;
				display: flex;
				align-items: flex-start;
				margin-top: 32rpx;
				.row-image {
					flex-shrink: 0;
					margin-right: 20rpx;
					width: 136rpx;
					height: 136rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					border-radius: 8rpx;
					border: 1rpx solid #E5E5E5;
					image {
						width: 100%;
					}
				}
				.row-info {
					flex: 1;
					font-weight: 400;
					font-size: 30rpx;
					color: #222222;
					margin-right: 30rpx;
					line-height: 42rpx;
				}
				.row-price {
					flex-shrink: 0;
					display: flex;
					flex-direction: column;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 30rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
							margin-top: 14rpx;
						}
					}
				}
			}
			.item-title {
				font-weight: 500;
				font-size: 30rpx;
				color: #222222;
			}
			.item-info {
				width: 100%;
				padding: 20rpx;
				box-sizing: border-box;
				background: #F8F9FB;
				border-radius: 8rpx;
				margin-top: 30rpx;
				font-weight: 400;
				font-size: 26rpx;
				color: #666666;
			}
			.item-user {
				width: 100%;
				display: flex;
				align-items: center;
				.item-user-image {
					flex-shrink: 0;
					width: 80rpx;
					height: 80rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
					overflow: hidden;
					margin-right: 20rpx;
					image {
						width: 100%;
					}
				}
				.item-user-info {
					flex: 1;
					height: 80rpx;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					text {
						&:nth-child(1) {
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
					}
				}
			}
		}
	}
</style>